<template>
  <v-app>
    <Header />
    <div>
      <v-container class="admin-page">
        <div class="media-exit-orderhistory">
          <v-form class="media-exit-order-filter">
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header
                  :hide-actions="true"
                  @click="expand = !expand"
                >
                  <v-row no-gutters>
                    <v-col class="d-flex justify-space-between">
                      <div class="media-exit-order">Order History</div>
                      <div class="media-exit-filter-box d-flex">
                        <span class="mx-1">Filter</span>
                        <span class="arrow" :class="expandarrow" />
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col cols="8" sm="6" md="8" class="mt-3">
                      <v-text-field
                        label="Subject"
                        v-model="filter.subject"
                        dense
                        @keyup.enter="submitFilter"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="6" md="4" class="mt-3">
                      <v-text-field
                        label="File Name"
                        v-model="filter.filename"
                        dense
                        @keyup.enter="submitFilter"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="6" md="4" class="pt-0">
                      <v-text-field
                        label="Sender Email"
                        v-model="filter.email_from"
                        dense
                        @keyup.enter="submitFilter"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="6" md="4" class="pt-0">
                      <v-text-field
                        label="Receiver Email"
                        v-model="filter.email_to"
                        dense
                        @keyup.enter="submitFilter"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="8" sm="6" md="4" class="pt-0">
                      <v-text-field
                        label="Channel / Sales Client Name"
                        v-model="filter.channelname"
                        dense
                        @keyup.enter="submitFilter"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      v-if="!expandChild"
                      cols="8"
                      sm="6"
                      md="4"
                      class="pt-0"
                    >
                      <v-menu
                        ref="adminorderdate1Menu"
                        v-model="adminorderdate1Menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        :return-value.sync="adminorderdate"
                        transition="scale-transition"
                        offset-y
                        content-class="custom-date-picker"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            ref="onPressadminOrder_Date1"
                            :value="adminOrderDateRange"
                            clearable
                            label="Order Date"
                            append-icon="mdi-calendar-month"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            class="media-exit-cal-input pt-0"
                            @click:clear="adminorderdate = []"
                            @keyup.enter="submitFilter"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="adminorderdate"
                          :min="adminorderdate[0]"
                          @change="onChangeOrderAdmin1"
                          range
                          dense
                          class="media-exit-date-picker"
                        >
                          <v-btn
                            text
                            color="primary"
                            @click="adminorderdate1Menu = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn text color="primary" @click="onClickOkOrder1">
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" md="12" class="pt-0">
                      <div>
                        <v-expansion-panels>
                          <v-expansion-panel>
                            <v-expansion-panel-content>
                              <v-row>
                                <v-col cols="8" sm="4" md="4" class="pt-0">
                                  <v-menu
                                    ref="adminorderdateMenu"
                                    v-model="adminorderdateMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="adminorderdate"
                                    transition="scale-transition"
                                    offset-y
                                    content-class="custom-date-picker"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        ref="onPressadminOrder_Date"
                                        :value="adminOrderDateRange"
                                        clearable
                                        label="Order Date"
                                        append-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        class="media-exit-cal-input pt-0"
                                        @click:clear="adminorderdate = []"
                                        @keyup.enter="submitFilter"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="adminorderdate"
                                      :min="adminorderdate[0]"
                                      @change="onChangeOrderAdmin"
                                      range
                                      dense
                                      class="media-exit-date-picker"
                                    >
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="adminorderdateMenu = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="onClickOkOrder"
                                      >
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="8" sm="4" md="4" class="pt-0">
                                  <v-menu
                                    ref="adminEmailMenu"
                                    v-model="adminEmailMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="admin_email_sentdate"
                                    transition="scale-transition"
                                    offset-y
                                    content-class="custom-date-picker"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        ref="onPressadminEmail_Date"
                                        :value="adminEmailSentDateRange"
                                        clearable
                                        label="Email Sent Date"
                                        append-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        class="media-exit-cal-input pt-0"
                                        @click:clear="admin_email_sentdate = []"
                                        @keyup.enter="submitFilter"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="admin_email_sentdate"
                                      :min="admin_email_sentdate[0]"
                                      @change="onChangeEmailAdmin"
                                      dense
                                      range
                                      class="media-exit-date-picker"
                                    >
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="adminEmailMenu = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="onClickOkEmail"
                                      >
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="8" sm="4" md="4" class="pt-0">
                                  <v-menu
                                    ref="adminRestoreMenu"
                                    v-model="adminRestoreMenu"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="adminrestoredate"
                                    transition="scale-transition"
                                    offset-y
                                    content-class="custom-date-picker"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        ref="onPressadminRestore_Date"
                                        :value="adminRestorationDateRange"
                                        clearable
                                        label="Restoration Complete Date"
                                        append-icon="mdi-calendar-month"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        class="media-exit-cal-input pt-0"
                                        @click:clear="adminrestoredate = []"
                                        @keyup.enter="submitFilter"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                      v-model="adminrestoredate"
                                      :min="adminrestoredate[0]"
                                      @change="onChangeRestoreAdmin"
                                      range
                                      dense
                                      class="media-exit-date-picker"
                                    >
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="adminRestoreMenu = false"
                                      >
                                        Cancel
                                      </v-btn>
                                      <v-btn
                                        text
                                        color="primary"
                                        @click="onClickOkRestore"
                                      >
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>
                                <v-col cols="8" sm="6" md="4">
                                  <v-text-field
                                    label="ME Order ID"
                                    v-model="filter.order_id"
                                    dense
                                    @keyup.enter="submitFilter"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="8" sm="6" md="4">
                                  <v-text-field
                                    label="GPS Order ID"
                                    v-model="filter.gps_order_id"
                                    dense
                                    @keyup.enter="submitFilter"
                                  ></v-text-field>
                                </v-col>
                                <v-col cols="8" sm="6" md="4" class="os-admin">
                                  <v-select
                                    class="pt-0"
                                    v-model="filter.status"
                                    :items="adminOrderStatus"
                                    label="Order Status"
                                    @keyup.enter="submitFilter"
                                  ></v-select>
                                </v-col>
                                <v-col cols="8" sm="4" md="4" class="pt-0">
                                  <v-select
                                    class="pt-0"
                                    v-model="filter.delivery_method"
                                    :items="adminDeliveryMethods"
                                    label="Delivery Method"
                                    @keyup.enter="submitFilter"
                                  ></v-select>
                                </v-col>
                                <v-col cols="8" sm="4" md="4" class="pt-0">
                                  <v-select
                                    class="pt-0"
                                    v-model="filter.budgetCode"
                                    :items="codes"
                                    label="Budget Code"
                                    @input="budgetCodeSelected"
                                    @keyup.enter="submitFilter"
                                  ></v-select>
                                </v-col>
                                <v-col cols="8" sm="4" md="4" class="pt-0">
                                  <v-text-field
                                    class="pt-0"
                                    v-show="isOthersSelected"
                                    label="Type Here"
                                    v-model="othersMessage"
                                    rows="1"
                                    @keyup.enter="submitFilter"
                                  ></v-text-field>
                                </v-col>
                                <!--date picker-->
                              </v-row>
                            </v-expansion-panel-content>
                            <div class="align-center d-flex">
                              <span>
                                <v-expansion-panel-header
                                  :hide-actions="true"
                                  @click="expandChild = !expandChild"
                                  class="see-more-header"
                                >
                                  <v-row no-gutters class="align-center">
                                    <v-col>
                                      <div class="see-more-less">
                                        <div v-if="!expandChild">
                                          See more filters
                                          <v-icon large
                                            >mdi-chevron-down</v-icon
                                          >
                                        </div>
                                        <div v-if="expandChild">
                                          See less filters
                                          <v-icon large>mdi-chevron-up</v-icon>
                                        </div>
                                      </div>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                              </span>
                              <v-col class="d-flex justify-end">
                                <v-btn
                                  class="ma-2 media-exit-sub-btn"
                                  color="primary"
                                  tile
                                  @click="submitFilter"
                                  >Submit</v-btn
                                >
                                <v-btn
                                  class="ma-2 media-exit-reset-btn"
                                  tile
                                  color="default"
                                  @click="reset"
                                  >Reset All</v-btn
                                >
                              </v-col>
                            </div>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
        </div>
        <!--search results-->
        <div v-if="totalrecords === 0" class="d-flex">
          <v-col>
            <div class="media-exit-results">
              {{ 0 }} - {{ 0 }} of {{ 0 }} results
            </div>
          </v-col>
          <v-col>
            <div class="media-exit-no-orderCards">No Records Found</div>
          </v-col>
          <v-col>
            <div class="media-exit-export-all" :disabled="isExportDisabled">
              <div class="text-right media-exit-export-btn" tile color="white">
                <strong
                  >Export All
                  <div
                    class="media-exit-download-icon"
                    :disabled="isExportDisabled"
                  ></div>
                </strong>
              </div>
            </div>
          </v-col>
        </div>
        <div v-else>
          <div class="media-exit-searchResults mt-10">
            <v-row class="row justify-space-around-space-around align-center">
              <v-col>
                <div class="media-exit-results">
                  {{ startRecord }} - {{ endRecord }} of
                  {{ totalrecords }} results
                </div>
              </v-col>
              <v-col>
                <div v-if="totalrecords > 0">
                  <v-pagination
                    class="media-exit-pagination"
                    v-model="CurrentPage"
                    :length="totalPages"
                    :total-visible="7"
                    @next="nextPage"
                    @input="nextPage"
                    @previous="nextPage"
                  >
                  </v-pagination>
                </div>
              </v-col>
              <v-col class="export-all">
                <div :class="[isDisabled ? 'media-exit-export-all' : 'media-exit-export-btn a']">
                  <div
                    class="text-right media-exit-export-btn"
                    tile
                    color="white"
                  >
                    <a href="javascript:void(0)">
                      <strong @click="exportAll"
                        >Export All
                        <div
                          class="media-exit-download-icon"
                          :disabled="isExportDisabled"
                        ></div>
                      </strong>
                    </a>
                  </div>
                </div>
              </v-col>
            </v-row>
          </div>
          <!--order details card-->
          <div class="media-exit-orderCards admin-history-expand-panel">
          <v-form ref="formdata" v-model="valid" lazy-validation>
            <v-expansion-panels focusable multiple>
              <v-expansion-panel v-for="(record, i) in orderrecords" :key="i">
                <v-expansion-panel-header>
                  <v-row class="no-gutters">
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        ME Order ID:
                      </div>
                      <div class="mx-2 my-2 text-ellipsis" :title="12345678">
                        {{ record.order_id }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Order By:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="record.email_from"
                      >
                        {{ record.email_from }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Order Date:
                      </div>
                      <div class="mx-2 my-2" :v-model="date">
                        {{ moment(record.ordered_date).format("DD MMM YYYY") }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Order Status:
                      </div>
                      <div class="mx-2 my-2">{{ record.status }}</div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        No of Files:
                      </div>
                      <div class="mx-2 my-2">{{ record.number_of_files }}</div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Channel / Sales Client Name:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="record.channel"
                      >
                        {{ record.channel }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Budget Code:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="record.budget_code"
                      >
                        {{ record.budget_code }}
                      </div>
                    </v-col>
                    <v-col col="6" md="3" class="pb-2">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Email Sent Date:
                      </div>
                      <div class="mx-2 my-2 text-ellipsis">
                        {{
                          moment(record.email_sent_date).format(
                            "DD MMM YYYY"
                          ) === "Invalid date"
                            ? ""
                            : moment(record.email_sent_date).format(
                                "DD MMM YYYY"
                              )
                        }}
                      </div>
                    </v-col>
                    <v-col col="4" md="6">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Subject:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="record.subject"
                      >
                        {{ record.subject }}
                      </div>
                    </v-col>
                    <v-col col="8" md="6">
                      <div class="mx-2 my-2 media-exit-filter-head">
                        Message:
                      </div>
                      <div
                        class="mx-2 my-2 text-ellipsis"
                        :title="record.message"
                      >
                        {{ record.message }}
                      </div>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="expansion-panel-content-wrap">
                  <v-container class="expansion-panel-content-header py-0 px-3">
                    <v-row class="order-history-submit-section">
                      <v-col class="col-auto d-flex pa-0 mt-2 align-center">
                        <v-menu
                          v-model="record.dateMenu3"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :value="
                                moment(record.expiry_date).format('DD MMM YYYY')
                              "
                              label="Expiry Date"
                              append-icon="mdi-calendar-month"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                              :disabled="
                                record.orderCancelStatus === 'Canceled'
                                  ? true
                                  : false
                              "
                              class="media-exit-cal-input expiry-select-box"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="record.expiry_date"
                            @input="record.dateMenu3 = false"
                            :min="minDate"
                            :max="maxDate"
                            dense
                            class="media-exit-date-picker"
                          ></v-date-picker>
                        </v-menu>
                        <div class="ml-7">
                          <v-select
                            class="hide-v-text-field__details max-select-box"
                            v-model="record.max_downloads"
                            :items="MaxDownlaods"
                            item-text="text"
                            item-value="value"
                            label="Max Downloads"
                            :disabled="
                              record.orderCancelStatus === 'Canceled'
                                ? true
                                : false
                            "
                          ></v-select>
                        </div>

                        <div class="ml-7">
                          <v-text-field
                            class="
                              hide-v-text-field__details
                              media-exit-cal-input
                              gps-order-input
                            "
                            v-model="record.gps_order_id"
                            :rules="GPSRules"
                            label="GPS Order ID"
                            :disabled="
                              record.orderCancelStatus === 'Canceled'
                                ? true
                                : false
                            "
                          ></v-text-field>
                        </div>

                        <div class="ml-7">
                          <v-select
                            class="
                              hide-v-text-field__details
                              delivery-select-box
                            "
                            v-model="record.delivery_method"
                            :items="DeliveryMethods"
                            item-text="text"
                            item-value="value"
                            label="Delivery Method"
                            :disabled="
                              record.orderCancelStatus === 'Canceled'
                                ? true
                                : false
                            "
                          ></v-select>
                        </div>
                      </v-col>
                      <v-col
                        class="
                          d-flex
                          media-exit-content-btn-box
                          pa-0
                          align-center
                        "
                      >
                        <div class="d-flex align-center mr-10">
                          <span class="mr-3">Cancel All</span>
                          <div class="admin-expand-cancel mb-1">
                            <input
                              type="checkbox"
                              :class="[]"
                              v-model="record.cancel"
                              :disabled="
                                record.orderCancelStatus === 'Canceled'
                                  ? true
                                  : false
                              "
                              :style="{
                                opacity:
                                  record.orderCancelStatus === 'Canceled'
                                    ? 0.4
                                    : 1
                              }"
                            />
                          </div>
                        </div>
                        <div class="admin-history-search">
                          <v-btn
                            class="ma-2 media-exit-content-sub-btn"
                            color="primary"
                            tile
                            @click="submitChanges(record, i)"
                            :disabled="
                              record.orderCancelStatus === 'Canceled'
                                ? true
                                : false
                            "
                            >Submit</v-btn
                          >
                        </div>
                        <div class="admin-history-reset">
                          <v-btn
                            class="ml-2 media-exit-content-reset-btn"
                            tile
                            color="default"
                            @click="resetChanges(record)"
                            :disabled="
                              record.orderCancelStatus === 'Canceled'
                                ? true
                                : false
                            "
                            >Reset All</v-btn
                          >
                        </div>
                      </v-col>
                    </v-row>
                    <v-row>
                      <!-- ORDER HISTORY TABLE -->
                      <v-data-table
                        :headers="headers"
                        :items="record.ordered_items"
                        :hide-default-footer="true"
                        disable-pagination
                        class="media-exit-table"
                      >
                        <!--file details in table-->
                        <template v-slot:[`item.name`]="{ item }">
                          <v-row v-model="item.name">
                            <v-col
                              col="8"
                              sm="2"
                              md="12"
                              class="d-flex file-list"
                            >
                              <!--FILE SECTION STARTS HERE-->
                              <div class="file-list-items pa-0">
                                <div class="d-flex file-list">
                                  <div class="file-icon">
                                    <img
                                      src="../../assets/images/file.svg"
                                      alt="file"
                                      max-width="44"
                                      min-width="44"
                                    />
                                  </div>
                                  <div class="file-list-desc-section">
                                    <p
                                      class="file-list-name"
                                      :title="item['s3file'].file_name"
                                    >
                                      {{ item["s3file"].file_name }}
                                    </p>
                                    <p class="file-list-desc-modified mb-0">
                                      Modified Date:
                                      {{
                                        moment(
                                          item["s3file"].last_modified
                                        ).format("DD MMM YYYY, h:mm A")
                                      }}
                                      |
                                      {{
                                        item["s3file"].file_size
                                          | fileSizeConverter
                                      }}
                                    </p>
                                    <p class="file-list-desc mb-0">
                                      {{
                                        item["s3file"].bucket_name +
                                          "/" +
                                          item["s3file"].file_name
                                      }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              <!--FILE SECTION END HERE-->
                            </v-col>
                          </v-row>
                        </template>
                        <!--file status component in table-->
                        <template v-slot:[`item.status`]="{ item }">
                          <v-chip
                            :color="getColor(item['file_status'].status)"
                            class="
                              media-exit-status
                              admin-order-history-status-btn
                              mb-2
                            "
                            >{{ item["file_status"].status }}</v-chip
                          >
                          <div v-if="item.restoration_date !== null">
                            <div class="status-sub-title">Restored On</div>
                            <div class="status-label-date">
                              {{
                                moment(item.restoration_date).format(
                                  "DD MMM YYYY"
                                )
                              }}
                            </div>
                          </div>
                        </template>
                        <!--expiry date component in table -->
                        <template v-slot:[`item.ExpiryDate`]="{ item }">
                          <v-menu
                            v-model="item.fileExpiryDate"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                :value="
                                  moment(item.expiry_date).format('DD MMM YYYY')
                                "
                                append-icon="mdi-calendar-month"
                                readonly
                                v-bind="attrs"
                                v-on="on"
                                :disabled="
                                  item.file_status.status == 'Cancelled'
                                    ? true
                                    : false
                                "
                                :class="
                                  item.file_status.status == 'Cancelled'
                                    ? 'button-disabled'
                                    : 'media-exit-cursor'
                                "
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.expiry_date"
                              @input="item.fileExpiryDate = false"
                              :min="minDate"
                              :max="maxDate"
                              class="media-exit-date-picker"
                            ></v-date-picker>
                          </v-menu>
                        </template>
                        <!--max download component in table-->
                        <template v-slot:[`item.MaxDownlaods`]="{ item }">
                          <div class="max-download-input">
                            <v-select
                              v-model="item.max_downloads"
                              :items="MaxDownlaods"
                              item-text="text"
                              item-value="value"
                              :disabled="
                                item.file_status.status == 'Cancelled'
                                  ? true
                                  : false
                              "
                            >
                            </v-select>
                          </div>
                        </template>
                        <!--cancel checkbox component in table-->
                        <template v-slot:[`item.Cancel`]="{ item }">
                          <div class="admin-expand-cancel">
                            <input
                              type="checkbox"
                              :checked="checked"
                              v-model="item.cancel"
                              :items="item.cancel"
                              :disabled="
                                item.file_status.status == 'Cancelled'
                                  ? true
                                  : false
                              "
                              :style="{
                                opacity:
                                  item.file_status.status == 'Cancelled'
                                    ? 0.4
                                    : 1
                              }"
                            />
                          </div>
                        </template>
                        <!--popup once clicked on actions-->
                        <template v-slot:[`item.Actions`]="{ item }">
                          <div class="text-center">
                            <div class="download-popup">
                              <v-menu
                                v-model="item.history"
                                :close-on-content-click="false"
                                :nudge-width="900"
                                offset-overflow
                                offset-y
                                offset-x
                                left
                                class="media-exit-download-history-menu"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <div
                                    class="media-exit-actions"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="
                                      adminDownloadHistoryCall(item, index)
                                    "
                                  />
                                </template>
                                <v-card>
                                  <v-list
                                    v-for="filedetails in downloadHistoryData"
                                    :key="filedetails"
                                  >
                                    <div>
                                      <div
                                        class="
                                          d-inline-block
                                          pl-4
                                          pb-8
                                          font-weight-medium
                                        "
                                      >
                                        <strong>Download History</strong>
                                      </div>
                                      <div class="d-inline-block ml-1">
                                        <p :title="filedetails.file_name">
                                          ({{ filedetails.file_name }})
                                        </p>
                                      </div>
                                    </div>
                                    <v-list-item justify-center>
                                      <span class="no-records"
                                        ><h4
                                          class="justify-center"
                                          v-if="
                                            filedetails.downloadRecord
                                              .length === 0
                                          "
                                        >
                                          No Records Found
                                        </h4></span
                                      >
                                      <div
                                        v-if="
                                          filedetails.downloadRecord.length >= 1
                                        "
                                        class="media-exit-div mt-n4"
                                      >
                                        <table
                                          class="media-exit-download-history"
                                        >
                                          <thead>
                                            <tr class="font-weight-medium">
                                              <td>Email ID</td>
                                              <td>Date and Time</td>
                                              <td>IP Address</td>
                                            </tr>
                                          </thead>
                                          <tbody class="media-exit-tbody">
                                            <tr
                                              v-for="fields in filedetails.downloadRecord"
                                              :key="fields"
                                            >
                                              <td class="media-exit-tabledata">
                                                {{
                                                  fields.receiver.receiver_mail
                                                }}
                                              </td>
                                              <td class="media-exit-tabledata">
                                                {{ fields.downloadHistoryDate }}
                                                {{ timeFormate }}
                                              </td>
                                              <td class="media-exit-tabledata">
                                                {{ fields.IP_address }}
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                    </v-list-item>
                                  </v-list>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      @click="item.history = false"
                                    >
                                      Close
                                    </v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-menu>
                            </div>
                          </div>
                        </template>
                      </v-data-table>
                    </v-row>
                  </v-container>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-form>
          </div>
        </div>
        <v-row class="mb-12">
          <v-col>
            <div v-if="totalrecords > 0">
              <v-pagination
                class="media-exit-pagination"
                v-model="CurrentPage"
                :length="totalPages"
                :total-visible="7"
                @next="nextPage"
                @input="nextPage"
                @previous="nextPage"
              ></v-pagination>
            </div>
          </v-col>
        </v-row>
        <div class="media-exit-footer">
          <hr />
          <p>©2020, A&E Television Networks, LLC. All Rights Reserved</p>
        </div>
      </v-container>
    </div>
  </v-app>
</template>
<script>
import moment from "moment";
import { format, parseISO } from "date-fns";
import Header from "../Header/HeaderPage";
export default {
  name: "Admin",
  props: {
    msg: String
  },
  components: {
    Header
  },
  data() {
    const defaultForm = Object.freeze({
      channel: "",
      pageCount: 0
    });

    return {
      expandChild: false,
      form: Object.assign({}, defaultForm),
      valid: true,
      codes: [
        {
          text: "A+E International Pays (505100)",
          value: "A+E International Pays & 1000-100050000-444000500-PP-505100",
          disabled: false
        },
        {
          text: "Client Pays (140210)",
          value: "Client Pays & 1000-100050000-000000000-BS-140210",
          disabled: false
        },
        {
          text: "Client Pays (505101)",
          value: "Client Pays & 1000-100050000-444000500-505101",
          disabled: false
        },
        { text: "Other", value: "Other", disabled: false }
      ],
      adminOrderStatus: [
        { text: "Shipped", value: "shipped", disabled: false },
        {
          text: "In Progress",
          value: "In progress",
          disabled: false
        }
      ],
      adminDeliveryMethods: [
        {
          text: "Aspera Faspex",
          value: "Aspera Faspex",
          disabled: false
        },
        {
          text: "Aspera P2P",
          value: "Aspera P2P",
          disabled: false
        },
        { text: "Signiant", value: "Signiant", disabled: false }
      ],
      defaultForm,
      panel: [0, 1],
      isOthersSelected: false,
      othersMessage: "",
      history: false,
      message: false,
      expand: false,
      date: new Date(),
      minDate: format(parseISO(moment(new Date()).toISOString()), "yyyy-MM-dd"),
      date1: "",
      date2: "",
      exDate: "",
      adminorderdate: [],
      adminorderdateMenu: false,
      adminorderdate1Menu: false,
      admin_order_startDate: "",
      admin_order_endDate: "",
      adminEmailMenu: false,
      admin_email_sentdate: [],
      admin_email_startDate: "",
      admin_email_endDate: "",
      admin_restore_startDate: "",
      admin_restore_endDate: "",
      adminRestoreMenu: false,
      adminrestoredate: [],
      dateMenu: false,
      dateMenu2: false,
      dateMenu3: false,
      fileExpiryDate: false,
      orderExpiryDate: "",
      downloadHistoryDate: "",
      budgetCode: "",
      CurrentPage: 1,
      totalrecords: "",
      totalPages: 0,
      rowsPerPage: 20,
      checked: false,
      popup: false,
      page: 1,
      orderrecords: "",
      limit: undefined,
      startRecord: 0,
      endRecord: "",
      isButtonValid: false,
      admin_emailSentDate: "",
      admin_restoreDate: "",
      admin_orderDate: "",
      filter: {
        subject: "",
        filename: "",
        email_from: "",
        email_to: "",
        channelname: "",
        budgetCode: "",
        order_startDate: "",
        order_endDate: "",
        email_startDate: "",
        email_endDate: "",
        restore_startDate: "",
        restore_endDate: "",
        order_id: "",
        delivery_method: "",
        status: "",
        gps_order_id: "",
        other_code: ""
      },
      queryParam: {
        subject: "",
        file_name: "",
        budget_code: "",
        channel: "",
        email_from: "",
        receiver_mail: "",
        start_date: "",
        end_date: "",
        email_start_date: "",
        email_end_date: "",
        restore_start_date: "",
        restore_end_date: "",
        order_id: "",
        delivery_method: "",
        status: "",
        gps_order_id: "",
        other_code: ""
      },
      timeFormate: "EST",
      downloadHistoryData: [],
      headers: [
        {
          text: "File Details",
          align: "start",
          sortable: false,
          value: "name"
        },
        { text: "Status", value: "status", sortable: false, align: "center" },
        {
          text: "Expiry Date",
          value: "ExpiryDate",
          sortable: false,
          align: "center"
        },
        {
          text: "Max Downloads",
          value: "MaxDownlaods",
          sortable: false,
          align: "center"
        },
        { text: "Cancel", value: "Cancel", sortable: false, align: "center" },
        { text: "Actions", value: "Actions", sortable: false, align: "center" }
      ],
      GPSRules: [
        t => {
          if (t.length > 0) {
            let invalidGPS = "";
            let gpsid = t;
            if (!new RegExp(/^([0-9]){4}$/).test(gpsid)) {
              return "GPS ID should be of 4 digits";
            }
            if (invalidGPS.length) {
              return `Invalid GPS ID - ${invalidGPS.join(",")}`;
            }
          }
        }
      ],
      MaxDownlaods: [
        { text: "01", value: 1, disabled: false },
        { text: "02", value: 2, disabled: false },
        { text: "03", value: 3, disabled: false },
        { text: "04", value: 4, disabled: false },
        { text: "05", value: 5, disabled: false },
        { text: "06", value: 6, disabled: false },
        { text: "07", value: 7, disabled: false },
        { text: "08", value: 8, disabled: false },
        { text: "09", value: 9, disabled: false },
        { text: "10", value: 10, disabled: false }
      ],
      DeliveryMethods: [
        { text: "Aspera Faspex", value: "Aspera Faspex", disabled: false },
        { text: "Aspera P2P", value: "Aspera P2P", disabled: false },
        { text: "Signiant", value: "Signiant", disabled: false }
      ],
      disable: true,
      isDisabled: true
    };
  },
  mounted() {
    this.adminHistoryCall(null, 1);
  },
  computed: {
    maxDate() {
      var endDate = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        30 + this.date.getDate()
      );
      return endDate.toISOString().slice(0, 10);
    },
    isExportDisabled() {
      return this.totalrecords.length === 0;
    },
    fromDate() {
      return this.date1 ? moment(this.date1).format("DD MMM YYYY") : "";
    },
    toDate() {
      return this.date2 ? moment(this.date2).format("DD MMM YYYY") : "";
    },
    expDate() {
      return this.exDate ? moment(this.exDate).format("DD MMM YYYY") : "";
    },
    adminOrderDateRange() {
      this.admin_order_startDate = this.adminorderdate[0];
      this.admin_order_endDate = this.adminorderdate[1];
      this.admin_orderDate = this.adminorderdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_orderDate.join(" - ");
    },
    adminEmailSentDateRange() {
      this.admin_email_startDate = this.admin_email_sentdate[0];
      this.admin_email_endDate = this.admin_email_sentdate[1];
      this.admin_emailSentDate = this.admin_email_sentdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_emailSentDate.join(" - ");
    },
    adminRestorationDateRange() {
      this.admin_restore_startDate = this.adminrestoredate[0];
      this.admin_restore_endDate = this.adminrestoredate[1];
      this.admin_restoreDate = this.adminrestoredate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_restoreDate.join(" - ");
    },
    expandarrow() {
      let arrow = "rotate-arrow";
      if (this.expand === true) {
        return arrow;
      }
      return this.expand;
    }
  },
  methods: {
    onClickOkOrder() {
      this.$refs.adminorderdateMenu.save(this.adminorderdate);
      this.$refs["onPressadminOrder_Date"].$refs.input.focus();
      if (this.admin_orderDate.length === 1) {
        this.adminorderdate[1] = this.adminorderdate[0];
      }
      this.admin_orderDate = this.adminorderdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_orderDate.join(" - ");
    },
    onClickOkOrder1() {
      this.$refs.adminorderdate1Menu.save(this.adminorderdate);
      this.$refs["onPressadminOrder_Date1"].$refs.input.focus();
      if (this.admin_orderDate.length === 1) {
        this.adminorderdate[1] = this.adminorderdate[0];
      }
      this.admin_orderDate = this.adminorderdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_orderDate.join(" - ");
    },
    onClickOkEmail() {
      this.$refs.adminEmailMenu.save(this.admin_email_sentdate);
      this.$refs["onPressadminEmail_Date"].$refs.input.focus();
      if (this.admin_emailSentDate.length === 1) {
        this.admin_email_sentdate[1] = this.admin_email_sentdate[0];
      }
      this.admin_emailSentDate = this.admin_email_sentdate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_emailSentDate.join(" - ");
    },
    onClickOkRestore() {
      this.$refs.adminRestoreMenu.save(this.adminrestoredate);
      this.$refs["onPressadminRestore_Date"].$refs.input.focus();
      if (this.admin_restoreDate.length === 1) {
        this.adminrestoredate[1] = this.adminrestoredate[0];
      }
      this.admin_restoreDate = this.adminrestoredate.map(ele => {
        return moment(ele).format("DD MMM YYYY");
      });
      return this.admin_restoreDate.join(" - ");
    },
    onChangeOrderAdmin() {
      this.$refs.adminorderdateMenu.save(this.adminorderdate);
      this.$refs["onPressadminOrder_Date"].$refs.input.focus();
    },
    onChangeOrderAdmin1() {
      this.$refs.adminorderdate1Menu.save(this.adminorderdate);
      this.$refs["onPressadminOrder_Date1"].$refs.input.focus();
    },
    onChangeEmailAdmin() {
      this.$refs.adminEmailMenu.save(this.admin_email_sentdate);
      this.$refs["onPressadminEmail_Date"].$refs.input.focus();
    },
    onChangeRestoreAdmin() {
      this.$refs.adminRestoreMenu.save(this.adminrestoredate);
      this.$refs["onPressadminRestore_Date"].$refs.input.focus();
    },
    exportAll() {
      const domainUrl = "api/export/";
      let vm = this;
      let exportLimit = 1500;
      if (vm.limit > 1499) {
        this.$swal({
          icon: "warning",
          title: `The report is exceeding the maximum limit of ${exportLimit} records. Please refine your search and export the results`,
          type: "success",
          confirmButtonText: "OK",
          showCloseButton: true
        });
      } else {
        this.validateParams(this.queryParam)
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, this.queryParam)
          .then(data => {
            let results = data.data;
            let blob = new Blob([results], { type: "text/csv" });
            let link = document.createElement("a");
            let toDate = new Date();
            let getDate = toDate
              .toISOString()
              .slice(0, 10)
              .replace(/-/g, "");
            let todaysDate = moment(getDate).format("DDMMYYYY");
            let getTime = moment().format("HHmmss");
            link.href = window.URL.createObjectURL(blob);
            link.download =
              "Media+Exit_Orders Export_" + todaysDate + "_" + getTime + ".csv";
            link.click();
          });
      }
    },
    getColor(status) {
      if (status === "Cancelled") return "#CB4A5F";
      else if (status === "Expired") return "#CB4A5F";
      else if (status === "Archived") return "#E89D42";
      else if (status === "Restoring") return "#E89D42";
      else return "#80B336";
    },
    adminDownloadHistoryCall(item, index) {
      let orderItemId = item.order_item_id;
      this.popup = true;
      const domainUrl = `api/downloadhistory/${orderItemId}/`;
      this.downloadHistoryData = [];
      let vm = this;
      vm.$apiService
        .getData("get", `${domainUrl}`, {}, {}, null, null)
        .then(data => {
          data.data.downloadRecord.map(element => {
            element["downloadHistoryDate"] = moment(
              element.downloaded_date
            ).format("DD MMM YYYY, h:mm:ss A");
          });
          this.downloadHistoryData.push(data.data);
        });
    },
    adminHistoryCall(params, pageNo) {
      const domainUrl = "api/order/";
      let vm = this;
      this.validateParams(params);
      if (vm.$apiService) {
        vm.$apiService
          .getData("get", `${domainUrl}`, {}, {}, null, params)
          .then(data => {
            if (data) {
              data.data.results.order_history.map(element => {
                element["orderExpiryDate"] = moment(element.expiry_date).format(
                  "DD MMM YYYY"
                );
                element["orderCancelStatus"] = element.cancel
                  ? "Canceled"
                  : "Active";
              });
              this.totalrecords = data.data.count;
              this.orderrecords = data.data.results.order_history;
              this.limit = data.data.results.total_files;
              this.orderrecords.forEach(ele => {
                let Odate = ele.ordered_date.split("T")
                ele.ordered_date = Odate[0]
              })
            } else {
              this.totalrecords = 0;
              this.orderrecords = [];
            }
            this.updatePageCount(pageNo, this.totalrecords, this.rowsPerPage);
          });
      }
    },
    validateParams(params){
      if (params) {
        params.start_date =
          params.start_date === "Invalid date" ? "" : params.start_date;
        params.end_date =
          params.end_date === "Invalid date" ? "" : params.end_date;

        //for email sent date
        params.email_start_date =
          params.email_start_date === "Invalid date"
            ? ""
            : params.email_start_date;
        params.email_end_date =
          params.email_end_date === "Invalid date" ? "" : params.email_end_date;

        //for restoration complete date
        params.restore_start_date =
          params.restore_start_date === "Invalid date"
            ? ""
            : params.restore_start_date;
        params.restore_end_date =
          params.restore_end_date === "Invalid date"
            ? ""
            : params.restore_end_date;
      }
    },
    updatePageCount(pageNumber, totalRecords, rowPerPage) {
      this.totalPages =
        totalRecords % rowPerPage
          ? parseInt(totalRecords / rowPerPage) + 1
          : totalRecords / rowPerPage;
      this.startRecord = totalRecords
        ? (parseInt(pageNumber) - 1) * rowPerPage + 1
        : 0;
      this.endRecord =
        parseInt(pageNumber - 1) * rowPerPage + this.orderrecords.length;
    },
    submitFilter() {
      this.CurrentPage = 1;
      this.setQueryParams();
      this.adminHistoryCall(this.queryParam, 1);
      this.isDisabled = false;
    },
    setQueryParams() {
      this.filter.order_startDate = this.admin_order_startDate;
      let adminOrderEndtDate;
      if (typeof this.admin_order_endDate !== "undefined") {
        let _end_date = new Date(this.admin_order_endDate);
        _end_date.setDate(_end_date.getDate() + 1);
        adminOrderEndtDate = moment(_end_date).format("YYYY-MM-DD");
      }
      this.filter.order_endtDate = adminOrderEndtDate;
      let Admin_OrderStartDate =
        typeof this.filter.order_startDate === "undefined"
          ? ""
          : this.filter.order_startDate;
      let Admin_OrderEndDate =
        typeof this.filter.order_endtDate === "undefined"
          ? ""
          : this.filter.order_endtDate;

      //for email start and end dates
      this.filter.email_startDate = this.admin_email_startDate;
      let adminEmailendDate;
      if (typeof this.admin_email_endDate !== "undefined") {
        let _end_date = new Date(this.admin_email_endDate);
        _end_date.setDate(_end_date.getDate());
        adminEmailendDate = moment(_end_date).format("YYYY-MM-DD");
      }

      this.filter.email_endDate = adminEmailendDate;
      let Admin_EmailStartDate =
        typeof this.filter.email_startDate === "undefined"
          ? ""
          : this.filter.email_startDate;
      let Admin_EmailEndDate =
        typeof this.filter.email_endDate === "undefined"
          ? ""
          : this.filter.email_endDate;

      //for restore start and end date
      this.filter.restore_startDate = this.admin_restore_startDate;
      let adminRestoreEndDate;
      if (typeof this.admin_restore_endDate !== "undefined") {
        let _end_date = new Date(this.admin_restore_endDate);
        _end_date.setDate(_end_date.getDate());
        adminRestoreEndDate = moment(_end_date).format("YYYY-MM-DD");
      }
      this.filter.restore_endDate = adminRestoreEndDate;
      let Admin_RestoreStartDate =
        typeof this.filter.restore_startDate === "undefined"
          ? ""
          : this.filter.restore_startDate;
      let Admin_RestoreEndDate =
        typeof this.filter.restore_endDate === "undefined"
          ? ""
          : this.filter.restore_endDate;

      //for budget code other fields
      if (this.filter.budgetCode === "Other" && this.othersMessage !== "") {
        this.filter.budgetCode = "Other";
        this.filter.other_code = this.othersMessage;
      } else if (
        this.filter.budgetCode === "Other" &&
        this.othersMessage === ""
      ) {
        this.filter.budgetCode = "Other";
        this.filter.other_code = "";
      }

      this.queryParam.subject = this.filter.subject;
      this.queryParam.file_name = this.filter.filename;
      this.queryParam.budget_code = this.filter.budgetCode;
      this.queryParam.channel = this.filter.channelname;
      this.queryParam.email_from = this.filter.email_from;
      this.queryParam.receiver_mail = this.filter.email_to;
      this.queryParam.start_date = Admin_OrderStartDate;
      this.queryParam.end_date = Admin_OrderEndDate;
      this.queryParam.email_start_date = Admin_EmailStartDate;
      this.queryParam.email_end_date = Admin_EmailEndDate;
      this.queryParam.restore_start_date = Admin_RestoreStartDate;
      this.queryParam.restore_end_date = Admin_RestoreEndDate;
      this.queryParam.order_id = this.filter.order_id;
      this.queryParam.delivery_method = this.filter.delivery_method;
      this.queryParam.status = this.filter.status;
      this.queryParam.gps_order_id = this.filter.gps_order_id;
      this.queryParam.other_code = this.filter.other_code;
    },
    reset() {
      this.CurrentPage = 1;
      this.filter.subject = "";
      this.filter.filename = "";
      this.filter.email_from = "";
      this.filter.email_to = "";
      this.filter.channelname = "";
      this.filter.budgetCode = "";
      this.date1 = "";
      this.date2 = "";
      this.adminorderdate = [];
      this.admin_email_sentdate = [];
      this.adminrestoredate = [];
      this.filter.order_id = "";
      this.filter.delivery_method = "";
      this.filter.status = "";
      this.isOthersSelected = false;
      this.othersMessage = "";
      this.filter.gps_order_id = "";
      this.filter.other_code = "";
      this.setQueryParams();
      this.adminHistoryCall(null, 1);
      this.isDisabled = true;
    },
    nextPage(e) {
      let queryParam = {
        subject: this.queryParam.subject,
        file_name: this.queryParam.file_name,
        budget_code: this.queryParam.budget_code,
        channel: this.queryParam.channel,
        email_from: this.queryParam.email_from,
        receiver_mail: this.queryParam.receiver_mail,
        start_date: this.queryParam.start_date,
        end_date: this.queryParam.end_date,
        email_start_date: this.queryParam.email_start_date,
        email_end_date: this.queryParam.email_end_date,
        restore_start_date: this.queryParam.restore_start_date,
        restore_end_date: this.queryParam.restore_end_date,
        order_id: this.queryParam.order_id,
        delivery_method: this.queryParam.delivery_method,
        status: this.queryParam.status,
        gps_order_id: this.queryParam.gps_order_id,
        other_code: this.queryParam.other_code,
        page: this.CurrentPage
      };
      this.adminHistoryCall(queryParam, this.CurrentPage);
    },
    submitChanges(item, i) {
       this.$refs.formdata.validate();
       if(this.$refs.formdata.validate()){
         if (item.cancel) {
        let canceledCount = item.ordered_items.length;
        if (item.ordered_items) {
          item.ordered_items.forEach(ordItem => {
            if (ordItem.file_status.status === "Cancelled")
              canceledCount = canceledCount - 1;
          });
        }
        this.$swal({
          icon: "warning",
          title: `${canceledCount} files in this order will be cancelled. Are you sure you want to submit the changes?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCloseButton: true
        }).then(result => {
          if (result.value === true) {
            let idparam = item.order_id;
            const domainUrl = `api/order/${idparam}/`;
            let vm = this;
            vm.$apiService
              .getData("put", `${domainUrl}`, {}, item, null, null)
              .then(data => {
                let orderUpdated = [];
                orderUpdated.push(data.data);
                let updatedObj = this.orderrecords.map(
                  obj =>
                    orderUpdated.find(o => o.order_id === obj.order_id) || obj
                );
                this.orderrecords = updatedObj;
                item["orderCancelStatus"] = item.cancel ? "Canceled" : "Active";
                this.orderrecords[i]["orderCancelStatus"] = item.cancel
                  ? "Canceled"
                  : "Active";
                vm.$forceUpdate();
              });
          }
        });
      } else {
        let canceledFileCount = 0;
        let title = "";
        if (item.ordered_items) {
          item.ordered_items.forEach(orderItem => {
            if (orderItem.cancel === true)
              canceledFileCount = canceledFileCount + 1;
          });
        }
        title =
          canceledFileCount > 0
            ? `${canceledFileCount} files in this order will be cancelled. Are you sure you want to submit the changes?`
            : "Are you sure you want to submit the changes?";
        this.$swal({
          icon: "warning",
          title: title,
          type: "success",
          showCancelButton: true,
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCloseButton: true
        }).then(res => {
          if (res.value === true) {
            let idparam = item.order_id;
            const domainUrl = `api/order/${idparam}/`;
            let vm = this;
            vm.$apiService
              .getData("put", `${domainUrl}`, {}, item, null, null)
              .then(data1 => {
                let orderUpdated = [];
                orderUpdated.push(data1.data);
                let updatedObj = this.orderrecords.map(
                  obj =>
                    orderUpdated.find(o => o.order_id === obj.order_id) || obj
                );
                this.orderrecords = updatedObj;
                item["orderCancelStatus"] = item.cancel ? "Canceled" : "Active";
                this.orderrecords[i]["orderCancelStatus"] = item.cancel
                  ? "Canceled"
                  : "Active";
                vm.$forceUpdate();
              });
          }
        });
      }
    }
    },
    resetChanges(record) {
      this.$swal({
        icon: "warning",
        title: "Are you sure you want to reset the changes?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        showCloseButton: true
      }).then(res => {
        if (res.value === true) {
          let queryParam = {
            subject: this.queryParam.subject,
            file_name: this.queryParam.file_name,
            budget_code: this.queryParam.budget_code,
            channel: this.queryParam.channel,
            email_from: this.queryParam.email_from,
            receiver_mail: this.queryParam.receiver_mail,
            start_date: this.queryParam.start_date,
            end_date: this.queryParam.end_date,
            email_start_date: this.queryParam.email_start_date,
            email_end_date: this.queryParam.email_end_date,
            restore_start_date: this.queryParam.restore_start_date,
            restore_end_date: this.queryParam.restore_end_date,
            order_id: this.queryParam.order_id,
            delivery_method: this.queryParam.delivery_method,
            status: this.queryParam.status,
            gps_order_id: this.queryParam.gps_order_id,
            other_code: this.queryParam.other_code,
            page: this.CurrentPage
          };
          this.adminHistoryCall(queryParam, this.CurrentPage);
        }
      });
    },
    budgetCodeSelected() {
      if (this.filter.budgetCode === "Other") {
        this.isOthersSelected = true;
      } else if (
        this.filter.budgetCode ===
        "Client Pays & 1000-100050000-000000000-BS-140210"
      ) {
        this.isOthersSelected = false;
      } else if (
        this.filter.budgetCode ===
        "A+E International Pays & 1000-100050000-444000500-PP-505100"
      ) {
        this.isOthersSelected = false;
      } else if (
        this.filter.budgetCode ===
        "Client Pays & 1000-100050000-444000500-505101"
      ) {
        this.isOthersSelected = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "../admin/admin.scss";
</style>
<style lang="scss">
@import "../admin/admin_unscoped.scss";
</style>
